import dayjs from "dayjs"
import utcPlugin from "dayjs/plugin/utc";
import 'dayjs/locale/de'


dayjs.locale('de')
dayjs.extend(utcPlugin);
